import { createDataActionHook, IActionInput } from '@msdyn365-commerce/core';
import { IActionContext } from '@msdyn365-commerce/core-internal/dist/types/interfaces/action/IAction';

const postHook = async (_inputs: IActionInput | IActionInput[], currentOutput: any, ctx: IActionContext) => {
    // modify canonical url as desired
    if (!ctx.requestContext.app.config.overrideDefaultCanonicalURL) {
        return currentOutput;
    }
    let newCanonicalUrl = '';
    const splitCanonicalUrl = currentOutput.canonicalUrl.split('//');
    if (splitCanonicalUrl.length > 0 && splitCanonicalUrl[1].indexOf('-online') > -1) {
        const splitCanonicalUrlWithoutHost = splitCanonicalUrl[1].split('/');
        splitCanonicalUrlWithoutHost.splice(1, 1);
        newCanonicalUrl = `${splitCanonicalUrl[0]}//${splitCanonicalUrlWithoutHost.join('/')}`;
    } else {
        newCanonicalUrl = currentOutput.canonicalUrl;
    }
    return { ...currentOutput, canonicalUrl: newCanonicalUrl };
};

createDataActionHook({
    actionId: '@msdyn365-commerce-modules/page-summary/category-page-summary',
    postHook
});
